type ErrorWithResponse = {
  response?: {
    data?: {
      message?: string;
      error?: unknown;
    };
  };
  message?: string;
};

export function getErrorMessage(
  error: unknown,
  fallback = "Something went wrong",
) {
  if (typeof error === "string") return error;

  if (error && typeof error === "object") {
    const typedError = error as ErrorWithResponse;
    const errorPayload = typedError.response?.data?.error;

    if (errorPayload && typeof errorPayload === "object") {
      const nestedError = errorPayload as {
        message?: string;
        detail?: string;
        code?: string;
      };

      return (
        nestedError.message ||
        nestedError.detail ||
        nestedError.code ||
        fallback
      );
    }

    return (
      typedError.response?.data?.message ||
      (typeof errorPayload === "string" ? errorPayload : undefined) ||
      typedError.message ||
      fallback
    );
  }

  return fallback;
}
